<script lang="ts">
    import * as Dialog from "./ui/dialog/index.js";
    import * as Tooltip from "./ui/tooltip/index.js";
    import { Textarea } from "./ui/textarea/index.js";
    import Button from "./ui/button/button.svelte";
    import MessageSquare from "@lucide/svelte/icons/message-square";
    import { m } from "../messages.svelte.js";
    import { cn, getClient } from "../utils.js";

    interface Props {
        caseId: string;
        comment: string | null;
        onChanged?: () => void;
        class?: string;
    }

    const { caseId, comment, onChanged, class: className }: Props = $props();

    let localComment = $state<string | null>(comment);

    $effect(() => {
        localComment = comment;
    });

    let open = $state(false);
    let draft = $state("");

    const hasComment = $derived(!!localComment && localComment.trim().length > 0);

    function handleOpen() {
        draft = localComment ?? "";
        open = true;
    }

    async function handleSave() {
        localComment = draft.trim() || null;
        open = false;
        await getClient()["Upsert case comment"]({ jsonBody: { caseId, comment: draft } });
        onChanged?.();
    }
</script>

<div class={cn("flex items-center", className)} onclick={e => e.stopPropagation()}>
    <Tooltip.Root>
        <Tooltip.Trigger>
            <button
                class="text-muted-foreground hover:bg-accent hover:text-foreground relative inline-flex h-6 w-6 items-center justify-center rounded-md transition-colors"
                onclick={handleOpen}
            >
                <MessageSquare class="size-3.5" />
                {#if hasComment}
                    <span class="bg-primary absolute -top-0.5 -right-0.5 h-2 w-2 rounded-full"></span>
                {/if}
            </button>
        </Tooltip.Trigger>
        <Tooltip.Content class="max-w-64">
            {#if hasComment}
                <p class="line-clamp-3 text-xs">{localComment}</p>
            {:else}
                <p class="text-xs">{m["workbench.commentPlaceholder"]()}</p>
            {/if}
        </Tooltip.Content>
    </Tooltip.Root>
</div>

<Dialog.Root bind:open>
    <Dialog.Content>
        <Dialog.Header>
            <Dialog.Title>{m["workbench.commentDialogTitle"]()}</Dialog.Title>
        </Dialog.Header>
        <Textarea
            bind:value={draft}
            placeholder={m["workbench.commentPlaceholder"]()}
            class="min-h-48 resize-y"
        />
        <Dialog.Footer>
            <Button onclick={handleSave}>{m["workbench.commentSave"]()}</Button>
        </Dialog.Footer>
    </Dialog.Content>
</Dialog.Root>
